module.exports = __webpack_public_path__ + "images/start-your-career.webp";